var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-simple-table',{class:_vm.className,attrs:{"fixed-header":"","dense":_vm.dense,"v-bind":Object.assign({}, _vm.attr)}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }